import { isNil } from 'lodash';
import { type TabularDataTypeEnum } from 'venn-utils';
import type { CurrencyEnum } from 'venn-api';

const toNumberStyle = (dataType?: TabularDataTypeEnum, currency: string = 'USD') => {
  if (dataType === 'PERCENTAGE') {
    return { style: 'percent' };
  }
  if (dataType === 'NUMERIC') {
    return { style: 'decimal' };
  }
  if (dataType === 'CURRENCY') {
    return { style: 'currency', currency };
  }
  return undefined;
};

export const formatData = ({
  num,
  dataType,
  precision = 2,
  maxChars = 8,
  currency,
  skipKSuffixInFormatting = false,
}: {
  num?: number;
  dataType?: TabularDataTypeEnum;
  precision?: number;
  maxChars?: number;
  currency?: CurrencyEnum;
  skipKSuffixInFormatting?: boolean;
}) => {
  if (isNil(num)) {
    return '--';
  }
  // @ts-expect-error fixme: ts errors from upgrade to typescript 5.5.3'
  const longString = num.toLocaleString('en-us', {
    ...toNumberStyle(dataType, currency),
    maximumFractionDigits: precision,
    minimumFractionDigits: precision,
  });
  const isLessThanAMillion = dataType === 'PERCENTAGE' ? Math.abs(num) < 1_0_000 : Math.abs(num) < 1_000_000;
  return longString.length > maxChars
    ? // @ts-expect-error fixme: ts errors from upgrade to typescript 5.5.3'
      num.toLocaleString('en-us', {
        ...toNumberStyle(dataType, currency),
        notation: skipKSuffixInFormatting && isLessThanAMillion ? 'standard' : 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: skipKSuffixInFormatting && isLessThanAMillion ? 0 : precision,
        minimumFractionDigits: skipKSuffixInFormatting && isLessThanAMillion ? 0 : precision,
      })
    : longString;
};
